import React, {useEffect, useState} from 'react';
import axios from "axios";
import {Col, Container, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import Layout from "../../components/Layout";

const News = () => {
    const [posts, setPosts] = useState([])

    useEffect(() =>{
        axios(`https://613af3f5110e000017a453df.mockapi.io/News`)
            .then(({data}) => setPosts(data))
    },[])

    return (
      <Layout>
          <Container>
              <Row>
                  {
                      posts.map(item =>

                          <Col md={3}>
                              <Link to={`/details/${item.id}`}>
                                  <img src={item.image} alt=""/>
                                  <p>{item.title}</p>
                              </Link>
                          </Col>
                      )
                  }
              </Row>
          </Container>
      </Layout>
    );
};

export default News;